module.exports = __webpack_public_path__ + "img/alumni_active.ef159c66.svg";